import React, { useEffect, useState } from "react";
import { Modal, Table, Spin, message } from "antd";
import moment from "moment";
import request from "helper/request";

const RouteEstimateHistoryModal = ({ visible, onClose, routeId, estimateType }) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (visible && routeId && estimateType) {
      fetchHistory();
    }
  }, [visible, routeId, estimateType]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await request({
        url: `/admin/routes/${routeId}/route-price-history?t=${Date.now()}`,
        method: "GET",
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache"
        }
      });
      // The request helper unwraps the response, so response.data is the array directly
      setHistory(response.data || []);
    } catch (error) {
      console.error("Error fetching route price history:", error);
      message.error("Failed to load price history");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 160,
      render: (date) => moment(date).format("MMM DD, YYYY HH:mm")
    },
    {
      title: "Client Estimate",
      dataIndex: "clientEstimate",
      key: "clientEstimate",
      width: 120,
      render: (price) =>
        price !== null && price !== undefined
          ? `${window.CURRENCY_SYMBOL}${parseFloat(price).toFixed(2)}`
          : "-"
    },
    {
      title: "Driver Estimate",
      dataIndex: "driverEstimate",
      key: "driverEstimate",
      width: 120,
      render: (price) =>
        price !== null && price !== undefined
          ? `${window.CURRENCY_SYMBOL}${parseFloat(price).toFixed(2)}`
          : "-"
    },
    {
      title: "Client Final",
      dataIndex: "clientFinal",
      key: "clientFinal",
      width: 110,
      render: (price) =>
        price !== null && price !== undefined
          ? `${window.CURRENCY_SYMBOL}${parseFloat(price).toFixed(2)}`
          : "-"
    },
    {
      title: "Driver Final",
      dataIndex: "driverFinal",
      key: "driverFinal",
      width: 110,
      render: (price) =>
        price !== null && price !== undefined
          ? `${window.CURRENCY_SYMBOL}${parseFloat(price).toFixed(2)}`
          : "-"
    },
    {
      title: "Explanation",
      dataIndex: "explanation",
      key: "explanation",
      render: (text) => text || "-"
    }
  ];

  const title = "Price Edit History";

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={(e) => {
        e?.stopPropagation();
        onClose();
      }}
      footer={null}
      width={1000}
      onClick={(e) => e.stopPropagation()}
      maskClosable={false}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <Spin spinning={loading}>
          {history.length > 0 ? (
            <Table
              columns={columns}
              dataSource={history}
              rowKey={(record, index) => `${record.createdAt}-${index}`}
              pagination={false}
              size="small"
              onRow={() => ({
                onClick: (e) => e.stopPropagation()
              })}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
              No estimate history available
            </div>
          )}
        </Spin>
      </div>
    </Modal>
  );
};

export default RouteEstimateHistoryModal;
